import { useEffect, useMemo, useState } from "react";
import { Box, CircularProgress } from "@mui/material";

import TempleHero from "./TempleHero";
import WhyTemplesSection from "./WhyTemplesSection";
import FeaturedTemplesSection from "./FeaturedTemplesSection";
import HowItWorksSection from "./HowItWorksSection";
import RestorationStorySection from "./RestorationStorySection";
import MonthlySevakSection from "./MonthlySevakSection";
import NominateTempleSection from "./NominateTempleSection";
import FaqSection from "./FaqSection";
import { templesData } from "./templesData";
import { buildTemplesContent } from "./cms";
import { getFeaturedTemples, getTemplesCms, submitTempleNomination } from "../../api/services/templesService";

// Content is managed in Admin → Temples. Until the CMS answers we show a
// loader rather than the fallback copy, so edited text never flashes.
const TemplesPage = () => {
  const [cmsRows, setCmsRows] = useState(null);
  const [temples, setTemples] = useState([]);
  const [templesLoading, setTemplesLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getTemplesCms()
      .then((rows) => !cancelled && setCmsRows(rows))
      .catch(() => !cancelled && setCmsRows([]));
    getFeaturedTemples()
      .then((list) => !cancelled && setTemples(list))
      .catch(() => !cancelled && setTemples([]))
      .finally(() => !cancelled && setTemplesLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  const content = useMemo(() => (cmsRows ? buildTemplesContent(cmsRows, templesData) : null), [cmsRows]);

  if (!content) {
    return (
      <Box sx={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress sx={{ color: "#EC1B26" }} />
      </Box>
    );
  }

  return (
    <>
      <TempleHero hero={content.hero} stats={content.stats} />
      <WhyTemplesSection content={content.whyTemples} />
      <FeaturedTemplesSection content={content.featuredTemples} temples={temples} loading={templesLoading} />
      <HowItWorksSection content={content.howItWorks} />
      <RestorationStorySection content={content.restorationStory} />
      <MonthlySevakSection content={content.monthlySevak} donationBox={content.donationBox} />
      <NominateTempleSection content={content.nominate} onSubmit={submitTempleNomination} />
      <FaqSection content={content.faq} />
    </>
  );
};

export default TemplesPage;
